import axios from 'axios'
import { getSign } from '@/utils/auth'
// create an axios instance
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 25000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers['Content-Type'] = 'application/json'
    var time = Date.parse(new Date()) / 1000
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        _t: time
      }
      config.data = {
        ...config.data,
        sign: getSign(config.data)
      }
    } else {
      /* config.params = {
        _t: time,
        ...config.params
      }
      config.params = {
        sign: getSign(config.params),
        ...config.params
      } */
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js